module.exports = __webpack_public_path__ + "static/image2-282b853e9d68bc9c00ddd1912568093e.png";